import JournalBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/JournalBlockForm";
import HeroBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/HeroBlockForm";
import ProductListBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/ProductListBlockForm";
import TrustBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/TrustBlockForm";
import FaqsBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/FaqsBlockForm";
import ComplianceBarBlock from "../../models/blocks/ComplianceBarBlock";
import PageHeaderBlock from "../../models/blocks/PageHeaderBlock";
import LinkBlock from "../../models/blocks/LinkBlock";
import PageFooterBlock from "../../models/blocks/PageFooterBlock";
import FooterLinksBlock from "../../models/blocks/FooterLinksBlock";
import FooterBenefitsBlock from "../../models/blocks/FooterBenefitsBlock";
import AnnouncementBarBlock from "../../models/blocks/AnnouncementBarBlock";
export default {
  [AnnouncementBarBlock.NAME]: {
    default_announcement: {
      [ComplianceBarBlock.getTextAttributeName()]: 'Livraison gratuite aujourd\'hui !'
    }
  },
  [ComplianceBarBlock.NAME]: {
    default_compliance: {
      [ComplianceBarBlock.getTextAttributeName()]: 'Copyright © {from}-{to} {domain_name}. Tous droits réservés.'
    }
  },
  [PageHeaderBlock.NAME]: {
    default_header: {
      [PageHeaderBlock.getLinksAttributeName()]: [{
        [LinkBlock.getNameAttributeName()]: 'ACCUEIL'
      }, {
        [LinkBlock.getNameAttributeName()]: 'PRODUITS'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Faq'
      }, {
        [LinkBlock.getNameAttributeName()]: 'À Propos'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Contact'
      }]
    }
  },
  [PageFooterBlock.NAME]: {
    default_footer: {
      [PageFooterBlock.getSectionsAttributeName()]: [{}, {
        [FooterLinksBlock.getTitleAttributeName()]: 'Informations',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'Expédition et retour'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Faq'
        }, {
          [LinkBlock.getNameAttributeName()]: 'À Propos'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Contact'
        }]
      }, {
        [FooterLinksBlock.getTitleAttributeName()]: 'Pages légales',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'Condition d\'utilisation'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Politique de confidentialité'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Remboursement'
        }]
      }, {
        [FooterBenefitsBlock.getParagraphAttributeName()]: '<p><strong>Paiement sécurisé</strong></p><p><strong>livraison gratuite et rapide</strong><span><strong>( 5 à 8 jours )</strong></span></p>'
      }]
    }
  },
  [HeroBlockForm.NAME]: {
    home: {
      text: '<p style="text-align: justify; padding: 0.1px" dir="ltr"><span style="font-size: 20pt; color: #FFFFFF">Expérience d’achat en ligne incroyable!</span></p><p style="text-align: justify; padding: 0.1px" dir="ltr"></p><ul dir="auto" style="padding-inline-start: 24px"><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">Produits de haute qualité</span></p></li><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">Des remises incroyables</span></p></li><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">Délais de livraison rapides</span></p><p dir="auto" style="padding: 0.1px"></p></li></ul><p dir="auto" style="padding: 0.1px"><span style="font-size: 20pt; color: #FFFFFF">N\'hésitez pas! Vous allez adorer nos produits</span></p>',
      button_text: 'Découvrez nos promos'
    }
  },
  [ProductListBlockForm.NAME]: {
    discover_products: {
      title: 'Découvrez nos produits'
    }
  },
  [JournalBlockForm.NAME]: {
    amazing_delivery_experience: {
      title: 'Expérience de livraison satisfaisante',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="ltr">Vous pouvez passer votre commande sur notre site en toute tranquillité, nous nous sommes associés aux meilleurs coursiers du pays pour vous offrir un délai de livraison rapide de 5 à 8 jours, et un mode de paiement sécurisé en ligne, par carte.</p>'
    },
    best_customer_service: {
      title: 'Le meilleur service client',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="auto">Notre équipe de service client est toujours là pour répondre à vos questions et vous aider avec votre commande, ainsi que dans l\'après-vente.Nous faisons de notre mieux pour répondre à tous nos clients en moins de 24 heures. Si vous avez des questions, veuillez nous contacter à partir de <a target="_blank" rel="noopener noreferrer nofollow" href="/contact"><strong>cette page</strong></a><a target="_blank" rel="noopener noreferrer nofollow" href="https://maxcomshop.com/contact">.</a></p>'
    },
    about_us: {
      title: 'À PROPOS DE NOUS',
      paragraph: '<p dir="auto" style="padding: 0.1px">:domain_title est une boutique en ligne en :country_name spécialisée dans les produits et accessoires innovants qui rendront votre quotidien plus facile et beaucoup plus amusant.On fait de notre mieux pour fournir un support de qualité et des délais de livraison plus rapides à nos clients. Nous nous engageons à traiter vos commandes en moins de 24h, et à répondre à toutes vos questions à temps.Nous sommes heureux de vous accueillir dans notre magasin, n\'hésitez pas à passer des commandes à tout moment :) Votre satisfaction est notre priorité.</p>'
    }
  },
  [TrustBlockForm.NAME]: {
    satisfaction_guarantee: {
      title: 'Garantie de satisfaction à 100 %',
      paragraph: 'On vous offre la livraison gratuite sur tous les produits, et une garantie de 30 jours pour tester tranquillement votre achat.',
      badges_list: [{
        text: 'Livraison gratuite'
      }, {
        text: 'Garantie de retour'
      }, {
        text: 'Paiement sécurisé'
      }, {
        text: 'Support client rapide'
      }]
    }
  },
  [FaqsBlockForm.NAME]: {
    home: {
      title: 'FAQ',
      other_questions_title: 'Vous avez d\'autres questions?',
      other_questions_text: '<p style="color: #FFFFFF; text-align: center; padding: 0.1px" dir="ltr">Rendez-vous sur la page contact, et envoyez-nous votre message. Nous faisons de notre mieux pour répondre à tous nos clients en moins de 24h</p>',
      other_questions_button_text: 'Contactez-nous',
      faqs_list: [{
        title: 'COMMENT SUIVRE MES COMMANDES ET PAIEMENTS ?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Nous vous enverrons le numéro de suivi par e-mail juste après l\'expédition de votre commande.</span></p>'
      }, {
        title: 'ET SI J\'AI BESOIN DE RETOURNER LE PRODUIT ?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Ne vous inquiétez pas ! Contactez-nous dès que possible dans les 7 premiers jours suivant la réception de votre commande, et nous vous aiderons à traiter le retour et le remboursement ou l\'échange.</span></p>'
      }, {
        title: 'COMBIEN DE TEMPS FAUT-IL POUR OBTENIR MA COMMANDE ?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Votre commande sera livrée dans les 5-8 jours suivant la confirmation de la commande, en fonction du volume de commandes reçues. En cas de retard dans la réception de votre commande, veuillez nous contacter et nous vous aiderons à confirmer l\'état de votre commande.</span></p>'
      }, {
        title: 'QUELLES POSSIBILITÉS DE PAIEMENT ?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Vous pouvez payer par carte en ligne. La transaction est 100% sécurisée et nous ne sauvegardons pas les informations de votre carte.</span></p>'
      }, {
        title: 'QUE SE PASSE-T-IL SI MA LIVRAISON EST ENDOMMAGÉE OU PERDUE ?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Nous prenons ces problèmes très au sérieux et nous les traiterons au cas par cas. Pour plus d\'informations sur notre politique d\'échange et de remboursement, veuillez </span><a target="_blank" rel="noopener noreferrer nofollow" href="/shipping-return-policy"><span><strong>cliquer ici</strong></span></a><span>.<span></p>'
      }]
    }
  }
};